import React from "react";
import LoaderGif from "../assets/pmiic_Loader.gif";

const style = {
  parent: {
    position: "absolute",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    margin: "auto",
    background: "rgba(0,0,0,0.5)",
    zIndex: "1000000000000",
    textAlign: "center",
    verticalAlign: "middle"
  },
  image: {
    width: "50px",
    height: "50px",
    margin: "auto",
    display: "block",
    top: "30%",
    position: "relative"
  }
};

export const ComponentLoader = ({
  isLoading,
  src,
  parentClass,
  childClass,
  tag
}) =>
  (isLoading && (
    <div style={style.parent}>
      {tag || (
        <img
          src={src || LoaderGif}
          className={childClass}
          style={style.image}
          alt=""
        />
      )}
    </div>
  )) ||
  null;
